import React, { useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { userNameHandler } from '../../util/local-storage';
import Typography from '@mui/material/Typography';
import { debounce } from '@mui/material/utils';
import { getWDFLocationList, postWDFChangeLocation } from './utils/api-action';
import CircularProgress from '@mui/material/CircularProgress';


const SwapOrderBranchModal: React.FC = (props) => {

    const userloginName = userNameHandler.get();
    const [display, setDisplay] = useState(props);
    const [btnSubmit, setBtnSubmit] = useState(false);

    const [notifyMessage, setNotifyMessage] = useState("");
    const [typeNotify, setTypeNotify] = useState('');
    const [openNotify, setNotify] = useState(false);

    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [NowLocation, setNowLocation] = useState([]);
    const [selectValue, setSelectValue] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [remark, setRemark] = useState("");
    const [remarkError, setRemarkError] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);

    // support options passed directly from parent — [{serviceCode, serviceDesc}]
    const propSupportOptions = props.supportOptions ?? [];
    const supportCodes = propSupportOptions.map(o => o.serviceCode);

    const getGroup = (option) =>
        supportCodes.includes(option.serviceCode) ? 'สาขาสำรอง' : 'ผลการค้นหา';

    useEffect(() => {
        if (!props.isDisplay) return;
        // pre-populate with support options synchronously — no fetch needed
        setSearchResults(propSupportOptions);
        setSelectValue([]);
        setInputValue('');
        setRemark('');
        setRemarkError(false);
        setConfirmOpen(false);
        setBtnSubmit(false);
        setDisplay(props);
    }, [props.isDisplay]);

    useEffect(() => {
        if (props.dataOrder) {
            setNowLocation([{
                locationCode: props.dataOrder?.location_code,
                locationDesc: props.dataOrder?.location_desc
            }]);
        }
    }, [props.dataOrder]);

    const debouncedSearch = useRef(debounce(async (value, supportOpts) => {
        if (!value) {
            setSearchResults(supportOpts);
            return;
        }
        try {
            setLoading(true);
            const response = await getWDFLocationList({ search: value });
            const found = response?.content?.content ?? [];
            const supportSet = new Set(supportOpts.map(o => o.serviceCode));
            const others = found.filter(r => !supportSet.has(r.serviceCode));
            setSearchResults([...supportOpts, ...others]);
        } catch (_) {}
        setLoading(false);
    }, 500)).current;

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick" && "escapeKeyDown") return;
        if (props.onClose != null) props.onClose(false);
        setDisplay({ ...props, isDisplay: false });
    };

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleNotify = () => setNotify(true);
    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') return;
        setNotify(false);
    };

    const doSubmit = () => {
        setBtnSubmit(true);
        const body = {
            "serviceNo": props.orderNo,
            "remark": remark,
            "source": props.dataOrder?.location_code,
            "destination": selectValue[0]?.serviceCode
        };
        postWDFChangeLocation(body).then(function (response) {
            if (response?.data?.code == 200) {
                setNotifyMessage('เปลี่ยนสาขาสำเร็จ');
                setTypeNotify('success');
                props.passSearchPossummary();
                handleNotify();
                props.onSuccess();
            } else {
                setNotifyMessage(response?.data?.description);
                setTypeNotify('error');
                handleNotify();
                setBtnSubmit(false);
            }
        }).catch(function () {
            setNotifyMessage('เปลี่ยนสาขาไม่สำเร็จ กรุณาลองอีกครั้ง');
            setTypeNotify('error');
            handleNotify();
            setBtnSubmit(false);
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (selectValue[0]?.serviceCode === undefined) {
            setNotifyMessage('กรุณาเลือกสาขาที่ต้องการเปลี่ยน');
            setTypeNotify('error');
            handleNotify();
            return;
        }
        if (remark.trim() === '') {
            setRemarkError(true);
            return;
        }
        const isSupport = supportCodes.includes(selectValue[0]?.serviceCode);
        if (!isSupport && supportCodes.length > 0) {
            setConfirmOpen(true);
        } else {
            doSubmit();
        }
    };

    return (
        <div>
            <Dialog open={display.isDisplay} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle className="border-b-2">{"แก้ไขสาขา"}</DialogTitle>
                <DialogContent className="m-4">
                    <Typography gutterBottom>
                        <div className="mt-10 justify-center items-center">
                            <div className="flex justify-center items-center">
                                <div className="pl-2 pr-2 w-1/3">
                                    <label className="font-bold">สาขาปัจจุบัน :</label>
                                </div>
                                <div className="pl-2 pr-2 w-2/3 mb-3">
                                    <TextField
                                        disabled={true}
                                        defaultValue={NowLocation[0]?.locationDesc || null}
                                        size="small"
                                        id="combo-box-demo1"
                                        sx={{ width: 300 }}
                                    />
                                </div>
                            </div>

                            <div className="flex justify-center items-center pt-2">
                                <div className="pl-2 pr-2 w-1/3">
                                    <label className="font-bold">สาขาที่ต้องการเปลี่ยน :</label>
                                </div>
                                <div className="pl-2 pr-2 w-2/3">
                                    <Autocomplete
                                        isOptionEqualToValue={(option, value) => option.serviceCode === value.serviceCode}
                                        getOptionDisabled={(option) => option.serviceCode === NowLocation[0]?.locationCode}
                                        groupBy={propSupportOptions.length > 0 ? getGroup : undefined}
                                        noOptionsText="ไม่มีรายการที่ค้นหา"
                                        size="small"
                                        sx={{ width: 300 }}
                                        blurOnSelect
                                        autoHighlight
                                        openOnFocus
                                        options={searchResults}
                                        getOptionLabel={(option) => option?.serviceDesc ?? ''}
                                        loading={loading}
                                        inputValue={inputValue}
                                        onInputChange={(event, value, reason) => {
                                            if (reason === 'reset') return;
                                            setInputValue(value);
                                            debouncedSearch(value, propSupportOptions);
                                        }}
                                        onChange={(event, newValue) => {
                                            setSelectValue(newValue ? [newValue] : []);
                                            setInputValue(newValue?.serviceDesc ?? '');
                                        }}
                                        renderOption={(props, option) => {
                                            const isSupport = supportCodes.includes(option.serviceCode);
                                            const isActive = option.isActive;
                                            return (
                                                <li id={option.serviceCode} style={{ cursor: "pointer" }} {...props}>
                                                    <div style={{ display: "flex", alignItems: "center", width: "100%", gap: 8 }}>
                                                        <div style={{ flex: 1 }}>
                                                            <div style={{ fontSize: "14px", color: "blue" }}>{option.serviceDesc}</div>
                                                            <div style={{ fontSize: "12px", color: "#888" }}>{option.serviceCode}</div>
                                                        </div>
                                                        {isSupport && (
                                                            <span style={{
                                                                fontSize: "11px", fontWeight: 600, padding: "2px 8px", borderRadius: 10, whiteSpace: "nowrap",
                                                                ...(isActive
                                                                    ? { backgroundColor: "rgba(20,161,110,0.15)", color: "rgb(14,120,80)", border: "1px solid rgba(20,161,110,0.4)" }
                                                                    : { backgroundColor: "rgba(220,53,69,0.15)", color: "rgb(185,28,28)", border: "1px solid rgba(220,53,69,0.4)" }
                                                                )
                                                            }}>
                                                                {isActive ? "● เปิดให้บริการ" : "● ไม่พร้อมให้บริการ"}
                                                            </span>
                                                        )}
                                                    </div>
                                                </li>
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="ค้นหาสาขา"
                                                variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex justify-center items-center mt-4">
                                <div className="pl-2 pr-2 w-1/3">
                                    <label className="font-bold">หมายเหตุ <span style={{ color: "red" }}>*</span> :</label>
                                </div>
                                <div className="pl-2 pr-2 w-2/3 mb-3">
                                    <TextField
                                        value={remark}
                                        onChange={(e) => { setRemark(e.target.value); if (e.target.value.trim() !== '') setRemarkError(false); }}
                                        style={{ width: "300px" }}
                                        className='mt-5 rounded p-1 text-left remark border'
                                        maxLength={200} minRows={3} type="text"
                                        id="text-area-remark"
                                        error={remarkError}
                                        helperText={remarkError ? 'กรุณากรอกหมายเหตุ' : ''}
                                    />
                                </div>
                            </div>
                        </div>
                    </Typography>
                </DialogContent>
                <DialogActions className="border-t-2">
                    <Button variant="contained" color="error" onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" color="primary" disabled={btnSubmit} onClick={onSubmit} autoFocus>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirmation dialog — selected branch is not in support list */}
            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>ยืนยันการเปลี่ยนสาขา</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span style={{ fontWeight: 600, color: "#d97706" }}>
                            {selectValue[0]?.serviceDesc} ({selectValue[0]?.serviceCode})
                        </span>{" "}
                        ไม่ใช่สาขาสำรองของ order นี้<br />
                        ต้องการเปลี่ยนไปสาขานี้ใช่หรือไม่?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={() => setConfirmOpen(false)}>ยกเลิก</Button>
                    <Button variant="contained" color="warning" onClick={() => { setConfirmOpen(false); doSubmit(); }}>
                        ยืนยัน
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={openNotify}
                autoHideDuration={6000}
                onClose={handleCloseDialog}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                key={"top" + "center"}
            >
                <Alert onClose={handleCloseDialog} severity={typeNotify} sx={{ width: "100%" }}>
                    {notifyMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default SwapOrderBranchModal;
